<template>
  <div
    v-if="(suggestedValues || {}).suggestedResponseTemplateId"
    class="suggested-item-container"
  >
    <div class="flex flex-1">
      <MTooltip placement="topLeft">
        <template v-slot:trigger>
          <div class="text-ellipsis">
            <div class="font-bold">
              {{ $tc('suggested') }} {{ $tc('template') }}
            </div>
            {{ responseTemplate.name }}
          </div>
        </template>
        {{ responseTemplate.name }}
      </MTooltip>
    </div>
    <div class="flex items-center">
      <MTooltip placement="topLeft">
        <template v-slot:trigger>
          <MIcon
            name="check"
            size="2x"
            class="cursor-pointer"
            @click="handleSuggestedItemSelect"
          />
        </template>
        {{ $t('insert') }} {{ $t('from') }} {{ $tc('template') }}
      </MTooltip>
    </div>
  </div>
</template>

<script>
import { getResponseTemplateApi } from '@modules/response-template/response-template-api'
export default {
  name: 'SuggestedResponseTemplate',
  inject: ['suggestedFieldValuesContext'],
  props: {
    resource: { type: Object, required: true },
  },
  data() {
    return {
      responseTemplate: {},
    }
  },
  computed: {
    suggestedValues() {
      // return { suggestedResponseTemplateId: 1 }
      let value
      const fieldValue =
        (
          (this.suggestedFieldValuesContext || {}).suggestedFieldValues || []
        ).find((i) => i.refId === this.resource.id) || {}
      if ((fieldValue || {}).suggestedResponseTemplateId) {
        value = fieldValue
      }
      return value
    },
  },
  watch: {
    'suggestedValues.suggestedResponseTemplateId': {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          getResponseTemplateApi(newValue).then((data) => {
            this.responseTemplate = data
          })
        }
      },
    },
  },
  methods: {
    handleSuggestedItemSelect() {
      this.$emit('insert', this.responseTemplate)
    },
  },
}
</script>

<style lang="less" scoped>
.suggested-item-container {
  @apply rounded mx-4 mb-3 p-2 flex;

  color: var(--secondary-green);
  background: var(--success-outline-button-hover-bg);
}
</style>
